<ng-container *transloco="let t; prefix: scope">
  <div class="h-full w-full flex items-center justify-center">
    <div class="w-2/3 max-w-3xl ml-4">
      <div class="max-w-xl">
        <h1 class="text-headline font-bold mb-4">{{ t('welcomeToWorkflowTitle') }}</h1>
        <p class="text-sub-headline mb-10">
          {{ t('welcomeToWorkflowDescription') }}
        </p>
        @if ((loggingIn$ | async) === false) {
          <bl-frontend-button
            variant="primary"
            (onclick)="login()"
            [trailingIcon]="{ name: 'arrow-right-to-bracket' }"
            [text]="t('login')">
          </bl-frontend-button>
        } @else {
          <bl-frontend-loading-button
            variant="primary"
            [loading]="true"
            [disabled]="true"
            [text]="t('loggingInPleaseWait')">
          </bl-frontend-loading-button>
        }
        <p class="text-description mt-10" [innerHTML]="t('dontHaveLundifyWorkflow')"></p>
      </div>
    </div>

    <div class="w-1/3 max-w-xl h-full py-10 mr-4">
      <!-- Laptop image -->
      <img src="/assets/login-image.svg" alt="Lundify Workflow" class="h-full relative overflow-hidden" />
    </div>
  </div>
</ng-container>
